<template>
    <footer class="checkout-footer">
        <div>
            <button class="btn btn-light text-uppercase checkout-footer-back-btn" :class="{'btn-icon-left': !isMobile, 'btn-shadow btn-rounded': isMobile}" @click.prevent="back">
                <span class="material-icon icon-keyboard_arrow_left"></span>
                <template v-if="!isMobile">{{ $t('back') }}</template>
            </button>
            <ul v-if="isMobile" class="mobile-menu__actions">
                <li class="mobile-menu__action">
                    <a href="#" @click.prevent="$emit('close-checkout')" class="action-link">
                        <span class="material-icon icon-clear"></span>
                        <span class="action-link__txt">{{ $t('cancel') }}</span>
                    </a>
                </li>
            </ul>
        </div>
        <div>
            <button v-if="[2, 4, 6].indexOf(parseInt(step)) >= 0" class="btn btn-success btn-shadow text-uppercase"
                    :class="{'btn-icon-right': [2, 4, 6].indexOf(parseInt(step)) >= 0}"
                    id="nextStepBtn"
                    @click.prevent="next">
                <template v-if="!isMobile">
                    <template v-if="step === 4">
                        {{ $t(isMobile ? 'skip' : 'skip_and_next') }}
                        <span class="material-icon icon-keyboard_arrow_right"/>
                    </template>
                    <template v-else-if="step === 6">
                        {{ $t('order_btn') }}
                        <span class="material-icon icon-add_shopping_cart"/>
                    </template>
                    <template v-else>
                        {{ $t('next') }}
                        <span class="material-icon icon-keyboard_arrow_right"/>
                    </template>
                </template>
                <template v-else>
                    <template v-if="step === 6">
                        <span class="material-icon icon-add_shopping_cart"/>
                    </template>
                    <template v-else>
                        <span class="material-icon icon-keyboard_arrow_right"/>
                    </template>
                </template>
            </button>
        </div>
    </footer>
</template>

<style lang="scss">
    .checkout-footer {
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 100px;
        padding: 15px 60px;
        left: 0;
        bottom: 0;
        background-color: var(--bg-color);
        z-index: 1;

        > div {
            flex-grow: 1;
            width: 100%;
            text-align: center;

            &:first-child {
                text-align: left;
            }

            &:last-child {
                text-align: right;
            }
        }

        a {
            color: inherit;
        }
    }

    body.-is-mobile {

        .checkout-footer {
            height: 80px;
            padding: 0 20px;
        }
    }
</style>

<script>
  import checkoutFooter from 'src/mixins/checkoutFooterComponent';

  export default {
    mixins: [checkoutFooter],
  };
</script>